export default __webpack_public_path__ + "static/media/Info_purple.715a7512.svg";